const state = {
    user_id: 0,
    name: "",
    email: "",
    picture: "",
    phone_number: "",
    school: "",
    student_number: "",
    birth_date: "",
    grade: "",
    group_schedule: "",
    is_active: false,
    is_nf_student: false,
    expired_at: null,
    user_app_scopes: [],
    user_scopes_expired: [],
    package_id: null,
};

const mutations = {
    usman_init: function (state, payload) {
        state.user_id = payload.user_id;
        state.name = payload.name;
        state.email = payload.email;
        state.picture = payload.picture;
        state.phone_number = payload.phone_number;
        state.school = payload.school;
        state.student_number = payload.student_number;
        state.birth_date = payload.birth_date;
        state.grade = payload.grade;
        state.group_schedule = payload.group_schedule;
        state.is_active = payload.is_active;
        state.is_nf_student = payload.is_nf_student;
        state.expired_at = payload.expired_at;
        state.user_app_scopes = payload.user_app_scopes;
        state.user_scopes_expired = payload.user_scopes_expired;
    },

    package_init: function (state, payload) {
        state.user_id = payload.user_id;
        state.package_id = payload.package_id;
    },
};

export default { state, mutations };



// WEBPACK FOOTER //
// ./src/modules/usman/stores/usman.js